import { render } from "./SecureAndAffordable.vue?vue&type=template&id=451df856&scoped=true"
const script = {}

import "./SecureAndAffordable.vue?vue&type=style&index=0&id=451df856&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451df856"]])

export default __exports__